import React from 'react';
import { apiHolder as api, apis } from 'api';
import RevokeCountDown from '@web-mail/components/RevokeCountDown/RevokeCountDown';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { useAppDispatch } from '@web-common/state/createStore';
import { reOpenMail } from '@web-mail/util';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const RevokeTip = ({ sendingMail }) => {
    const { id, createTime } = sendingMail;
    const dispatch = useAppDispatch();
    const revoke = async () => {
        trackApi.track('pcMail_click_cancelSend_mailDetailPage', {});
        const { id, tid, sentTInfo } = sendingMail;
        dispatch(mailActions.doRemoveSendingMail(id));
        try {
            const cancelRes = await mailApi.doCancelDeliver({ tid, tinfo: sentTInfo, mailTrace: true });
            if (!cancelRes.success) {
                return;
            }
            reOpenMail(sendingMail);
        }
        catch (error) {
            console.log('撤销失败', error);
        }
    };
    return (React.createElement("div", { className: "mail-revoke" },
        React.createElement("div", { className: "mail-count-down" },
            React.createElement(RevokeCountDown, { id: id, createTime: createTime, attrs: {
                    strokeColor: '#4C6AFF',
                    strokeLinecap: 'butt',
                    trailColor: '#E1E3E8',
                    strokeWidth: 7.5,
                    width: 21,
                }, leftSecStyle: {
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#4C6AFF',
                } })),
        React.createElement("span", { className: "mail-sending" }, getIn18Text('FASONGZHONG..')),
        React.createElement("div", { className: "mail-revoke-button", onClick: () => revoke() }, getIn18Text('CHEXIAO'))));
};
export default RevokeTip;
